// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__6Gu7m","sendOtp":"AuthorizeToLogin_sendOtp__1ESyV"};